import { render, staticRenderFns } from "./BaseDhmeDoubleTrestle.vue?vue&type=template&id=8e95de0c&scoped=true"
import script from "./BaseDhmeDoubleTrestle.vue?vue&type=script&lang=js"
export * from "./BaseDhmeDoubleTrestle.vue?vue&type=script&lang=js"
import style0 from "./BaseDhmeDoubleTrestle.vue?vue&type=style&index=0&id=8e95de0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e95de0c",
  null
  
)

export default component.exports